import { IconName } from '../atoms/icons/icon';

// the raw event types that are retrieved via APIs
// TODO: Change CONFIRMED_COLLISION_VERA2 back to orginal format after cutoff date - NAUTO-41042
export enum EventType {
  ACCELERATION = 'acceleration-hard',
  BRAKING = 'braking-hard',
  BRAKING_SEVERE = 'braking-severe',
  BRAKING_HARD_SEVERE = 'braking-hard-severe',
  CELL_PHONE = 'cell-phone',
  CORNERING_LEFT = 'corner-left-hard',
  CORNERING_RIGHT = 'corner-right-hard',
  DISTRACTION = 'distraction',
  CONFIRMED_DISTRACTION = 'review-confirmed-distraction',
  TAILGATING = 'tailgating',
  CONFIRMED_TAILGATING = 'review-confirmed-tailgating',
  MARK = 'mark',
  MARK_PANIC = 'mark-panic',
  REQUEST = 'custom-video-request',
  POSSIBLE_COLLISION = 'severe-g-event',
  SMOKING = 'smoking',
  UNSURE_COLLISION = 'review-unsure-severe-g-event',
  CONFIRMED_COLLISION_VERA2 = 'review-confirmed-severe-g-event',
  CONFIRMED_COLLISION_VERA3 = 'collision',
  SNAPSHOT_IN = 'snapshot-in',
  SNAPSHOT_OUT = 'snapshot-out',
}

// the presentation of each event type in the UIs
// KEY - the raw event message type
export interface TypeMap {
  kind: Kind; // kind - the variety of event - determines color and some display logic
  name: string; // name - the displayed text for that event
  icon: IconName; // iconPath - the path of the event icon to use
}

export enum Kind {
  risk = 'risk',
  action = 'action',
  collision = 'collision',
  subtype = 'subtype',
}

export const eventDisplayMap: { [kind: string]: TypeMap } = {
  [EventType.ACCELERATION]: {
    kind: Kind.risk,
    name: 'acceleration',
    icon: 'acceleration',
  },
  [EventType.BRAKING]: {
    kind: Kind.risk,
    name: 'braking-hard',
    icon: 'braking',
  },
  [EventType.BRAKING_SEVERE]: {
    kind: Kind.risk,
    name: 'severe-braking',
    icon: 'braking',
  },
  [EventType.BRAKING_HARD_SEVERE]: {
    kind: Kind.risk,
    name: 'severe-braking',
    icon: 'braking',
  },
  [EventType.CORNERING_LEFT]: {
    kind: Kind.risk,
    name: 'cornering',
    icon: 'cornering',
  },
  [EventType.CORNERING_RIGHT]: {
    kind: Kind.risk,
    name: 'cornering',
    icon: 'cornering',
  },
  [EventType.DISTRACTION]: {
    kind: Kind.risk,
    name: 'distraction',
    icon: 'distraction',
  },
  [EventType.CONFIRMED_DISTRACTION]: {
    kind: Kind.risk,
    name: 'distraction',
    icon: 'distraction',
  },
  [EventType.TAILGATING]: {
    kind: Kind.risk,
    name: 'tailgating',
    icon: 'tailgating',
  },
  [EventType.CONFIRMED_TAILGATING]: {
    kind: Kind.risk,
    name: 'tailgating',
    icon: 'tailgating',
  },
  [EventType.POSSIBLE_COLLISION]: {
    kind: Kind.collision,
    name: 'possible-collision',
    icon: 'collision',
  },
  [EventType.UNSURE_COLLISION]: {
    kind: Kind.collision,
    name: 'possible-collision',
    icon: 'collision',
  },
  [EventType.CONFIRMED_COLLISION_VERA2]: {
    kind: Kind.collision,
    name: 'collision',
    icon: 'collision',
  },
  [EventType.CONFIRMED_COLLISION_VERA3]: {
    kind: Kind.collision,
    name: 'collision',
    icon: 'collision',
  },
  [EventType.MARK]: {
    kind: Kind.action,
    name: 'marked',
    icon: 'star',
  },
  [EventType.MARK_PANIC]: {
    kind: Kind.action,
    name: 'panic-button',
    icon: 'panic',
  },
  [EventType.REQUEST]: {
    kind: Kind.action,
    name: 'requested',
    icon: 'videoRequest',
  },
  [EventType.CELL_PHONE]: {
    kind: Kind.subtype,
    name: 'cell-phone',
    icon: 'cellPhone',
  },
  [EventType.SMOKING]: {
    kind: Kind.subtype,
    name: 'smoking',
    icon: 'cigarette',
  },
};

export default eventDisplayMap;
